import React, { useMemo } from 'react'
import { useWebsiteSettings } from 'client/store/index'
import {
  getWebsiteId,
  getWebsiteLocale,
} from 'src/editor/store/website-settings/website-settings-selector'
import { useQueryWebsitePages } from 'src/editor/api/hooks/use-query-website-pages'
import {
  OptionSingleValueType,
  OptionType,
  SelectNew,
} from 'src/editor/shared/ui-lib/select-new/select-new'
import { getWebsitePageReplacement } from 'common/utils/website-replacements-utils'

type WebsiteLinkProps = {
  update: (val: string) => void
  link: string | null
  className?: string
}

export const WebsiteLink = ({ update, link, className }: WebsiteLinkProps) => {
  const websiteLocale = useWebsiteSettings(getWebsiteLocale)
  const websiteId = useWebsiteSettings(getWebsiteId) as number

  const { data, isFetching } = useQueryWebsitePages(websiteId)

  const options = useMemo(() => {
    return (
      data?.pages.reduce((acc, websitePageSet) => {
        const websitePage = websitePageSet.locales.find(
          ({ locale }) => locale === websiteLocale,
        )
        if (websitePage) {
          acc.push({
            value: getWebsitePageReplacement(websitePage.pageContentId),
            label: websitePage.name,
          })
        }
        return acc
      }, [] as OptionType[]) || []
    )
  }, [data, websiteLocale])

  const onChangeOption = (option: OptionSingleValueType) => {
    if (option) {
      update(option.value)
    }
  }

  const selectedOption = useMemo(() => {
    return options.find(option => option.value === link) || null
  }, [options, link])

  return (
    <SelectNew
      className={className}
      isLoading={isFetching}
      withoutWrapper
      onChange={onChangeOption}
      options={options}
      selectedOption={selectedOption}
    />
  )
}
